import { render, staticRenderFns } from "./ActiveExchangeOnlyGoods.vue?vue&type=template&id=452c03c0&scoped=true&"
import script from "./ActiveExchangeOnlyGoods.vue?vue&type=script&lang=js&"
export * from "./ActiveExchangeOnlyGoods.vue?vue&type=script&lang=js&"
import style0 from "./ActiveExchangeOnlyGoods.vue?vue&type=style&index=0&id=452c03c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c03c0",
  null
  
)

export default component.exports